import { __ } from '@wordpress/i18n';

export default {
	message: __( 'Find your perfect estate', 'kam001-real-estate-blocks' ),
};
